<h2 mat-dialog-title>Auto-save failed</h2>
<mat-dialog-content>
  There was an issue saving the change you have made. Please check your network
  connection, saving will retry every {{ draftSavePeriod }} seconds
  automatically.
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">OK</button>
  <button
    mat-button
    *ngIf="retryFn"
    (click)="retry()"
    [disabled]="isSaving$ | async"
    color="primary"
  >
    <ng-container *ngIf="isSaving$ | async">
      <mat-spinner [diameter]="24"></mat-spinner>
    </ng-container>
    <ng-container *ngIf="(isSaving$ | async) === false"> RETRY </ng-container>
  </button>
</mat-dialog-actions>
